import { Hash, Calendar, Tag, MapPin, Layers } from "lucide-react";
import {
  DetailRow,
  DetailGrid,
  SectionHeading,
} from "@/components/dashboard/dashboardDetailPrimitives";
import type { DecizieInregistrare } from "@/types/decizieInregistrare";

type DecizieInregistrareDetailsProps = {
  decizie: DecizieInregistrare;
};

export default function DecizieInregistrareDetails({
  decizie,
}: DecizieInregistrareDetailsProps) {
  return (
    <div className="space-y-2">
      <SectionHeading to="/onboarding/decizie-inregistrare">
        Decizie Inregistrare
      </SectionHeading>
      <DetailGrid>
        <DetailRow
          icon={Hash}
          label="Nr. inregistrare"
          value={decizie.registration_number ?? "-"}
          highlighted
        />
        <DetailRow
          icon={Hash}
          label="Nr. decizie"
          value={decizie.decision_number ?? "-"}
        />
        <DetailRow
          icon={Calendar}
          label="Data deciziei"
          value={decizie.decision_date ?? "-"}
        />
        <DetailRow
          icon={Tag}
          label="Categorie"
          value={decizie.category ?? "-"}
        />
        <DetailRow icon={MapPin} label="Județ" value={decizie.county ?? "-"} />
      </DetailGrid>
      {decizie.sectors.length > 0 && (
        <>
          <SectionHeading>Sectoare</SectionHeading>
          <div className="space-y-2">
            {decizie.sectors.map((sector) => (
              <div
                key={sector}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-gradient-to-r from-slate-50 to-white border border-slate-200 shadow-sm"
              >
                <div className="w-6 h-6 rounded bg-blue-50 flex items-center justify-center shrink-0">
                  <Layers size={12} className="text-blue-500" />
                </div>
                <span className="text-xs font-semibold text-slate-700">
                  {sector}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
